export default function About() {
  return (
    <section id="about" className="py-28 px-8 bg-[#faf8f5]">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
        {/* Image */}
        <div className="relative">
          <div className="relative rounded-2xl overflow-hidden" style={{ aspectRatio: '4/5' }}>
            <img
              src="https://storage.readdy-site.link/project_files/4b4055c4-1e9d-4e97-8d06-e41c79fbe298/6dfbac4d-c077-4031-b81e-0f03134a2e4c_moonseed.png?v=2b3f0c2fb6d33e8a7b228510eac8edcc"
              alt="サロン内観 ティファニーブルーの壁と木の温もり"
              className="w-full h-full object-cover object-top"
            />
          </div>
          {/* 2枚目の写真を右下に重ねて表示 */}
          <div className="absolute -bottom-8 -right-8 w-48 h-48 rounded-xl overflow-hidden border-4 border-white">
            <img
              src="https://storage.readdy-site.link/project_files/4b4055c4-1e9d-4e97-8d06-e41c79fbe298/c947b97c-b1af-44f7-a935-cfdb7e0ac350_moonseed2.png?v=17ec6577d8f1bc929af049178170ff81"
              alt="サロン内観 癒しの空間"
              className="w-full h-full object-cover object-center"
            />
          </div>
          {/* floating badge */}
          <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl p-5">
            <p className="text-[#6b7c5c] text-3xl font-light" style={{ fontFamily: "'Cormorant Garamond', serif" }}>5</p>
            <p className="text-stone-500 text-xs tracking-widest mt-1" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>年以上の実績</p>
          </div>
        </div>

        {/* Text */}
        <div className="flex flex-col gap-7">
          <div>
            <p
              className="text-[#6b7c5c] text-xs tracking-[0.35em] mb-4"
              style={{ fontFamily: "'Cormorant Garamond', serif" }}
            >
              Private Relaxation Salon
            </p>
            <h2
              className="text-stone-800 text-4xl md:text-5xl font-light leading-snug"
              style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.03em' }}
            >
              あなただけの
              <br />
              癒しの時間を
              <br />
              <span className="italic">お届けします</span>
            </h2>
          </div>
          <p
            className="text-stone-500 text-sm leading-8 tracking-wide"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            兵庫県尼崎市にある完全個室のプライベートリラクゼーションサロンです。
            日常の疲れや「なんとなく重だるい」そんなお悩みを、丁寧な施術で解きほぐします。
          </p>
          <p
            className="text-stone-500 text-sm leading-8 tracking-wide"
            style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
          >
            改善型アプローチにこだわり、一時的なほぐしではなく、
            根本からケアする質の高いリラクゼーションをご提供。
            完全予約制で、あなただけの時間と空間をご用意しています。
          </p>

          <div className="grid grid-cols-3 gap-6 pt-2">
            {[
              { num: '100%', label: '完全個室制' },
              { num: '4種', label: '施術メニュー' },
              { num: '★4.9', label: '平均評価' },
            ].map((item) => (
              <div key={item.label} className="flex flex-col gap-1">
                <span
                  className="text-2xl font-light text-stone-800"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {item.num}
                </span>
                <span
                  className="text-xs text-stone-400 tracking-widest"
                  style={{ fontFamily: "'Noto Sans JP', sans-serif" }}
                >
                  {item.label}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
